import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { blogEndpoints } from "../../services/api";
import toast from "react-hot-toast";
import { motion } from "framer-motion";
import "quill/dist/quill.snow.css"; // ✅ Import Quill CSS

const { GET_BLOG_BY_ID } = blogEndpoints;

export default function BlogDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    const apiUrl = GET_BLOG_BY_ID(id);
    console.log("Fetching Blog from API:", apiUrl);

    fetch(apiUrl)
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched Blog Data:", data);
        setBlog(data);
      })
      .catch((error) => {
        console.error("Error fetching blog:", error);
        toast.error("Failed to load blog");
      });
  }, [id]);

  if (!blog) {
    return <p className="text-center text-gray-500 text-lg mt-10">Loading blog content...</p>;
  }

  return (
    <div className="w-full flex flex-col items-center justify-center min-h-screen py-16 px-2 md:px-16 bg-white text-black mt-[10%]">
      {/* Back Button */}
      <motion.button
        onClick={() => navigate(-1)}
        whileHover={{ scale: 1.05 }}
        transition={{ duration: 0.3 }}
        className="absolute top-6 left-6 md:top-40 md:left-10 bg-[#C9A227] text-[#0F172A] px-4 py-2 rounded-lg shadow-md hover:bg-[#B79527] transition duration-300"
      >
        ← Back
      </motion.button>

      {/* Blog Content Wrapper */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-5xl bg-white p-1 rounded-lg  text-black"
      >
        {/* Blog Thumbnail */}
        {blog.thumbnail ? (
          <img
            src={blog.thumbnail}
            alt={blog.title}
            className="w-full max-h-[500px] object-cover rounded-lg shadow-md"
          />
        ) : (
          <p className="text-gray-500 text-center">No Thumbnail Available</p>
        )}

        {/* Blog Title & Meta Information */}
        <h2 className="text-3xl font-bold mt-6 text-[#0F172A] text-center md:text-left">
          {blog.title || "No Title"}
        </h2>
        <p className="text-gray-600 mt-2 text-center md:text-left">
           <span className="text-[#C9A227]">Date : </span> |{" "}
          {blog.createdAt ? new Date(blog.createdAt).toLocaleDateString() : "Date Not Available"}
        </p>

        {/* Blog Content */}
        <div
          className="mt-6 leading-relaxed text-justify ql-editor"
          dangerouslySetInnerHTML={{ __html: blog.content || "<p>No Content Available</p>" }}
        />
      </motion.div>
    </div>
  );
}
